"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeEvents = void 0;
var RealtimeEvents;
(function (RealtimeEvents) {
    RealtimeEvents["Created"] = "customer created";
    RealtimeEvents["Updated"] = "customer update";
    RealtimeEvents["Deleted"] = "customer delete";
})(RealtimeEvents = exports.RealtimeEvents || (exports.RealtimeEvents = {}));
//# sourceMappingURL=Customer.consts.js.map